module.exports = "/_next/static/images/Hero1@2x-492cafc9cd3f971ed1a3fbb21e51f4f4.png";